import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/js/bootstrap.bundle'
import '@/assets/scss/app.scss'
import VueFeather from 'vue-feather'
import Breadcrumbs from './components/bread_crumbs'

// Preferencia de idioma de versiones anteriores: el sistema es solo en español
try {
	localStorage.removeItem('currentLanguage');
	localStorage.removeItem('currentLanguageIcon');
} catch (e) { /* almacenamiento no disponible: se ignora */ }

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

createApp(App)
	.use(pinia)
	.use(router)
	.component(VueFeather.name, VueFeather)
	.component('Breadcrumbs', Breadcrumbs)
	.mount('#app')
